
'use client';
import React, { lazy, Suspense } from "react";
import Image from 'next/image';
import digiiImg from '../../assets/technology/digii.webp'
import leadsquaredImg from '../../assets/technology/leadsquared.webp'
import logicKnotsImg from '../../assets/technology/Logic-Knots.webp'
import merittoImg from '../../assets/technology/meritto.webp'
import tribujteImg from '../../assets/technology/tribujte.webp'
import wheeboxImg from '../../assets/technology/wheebox.webp'
import Title from "@/ui/Title";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const RECOGNITIONS = [
  { id: 1, src: digiiImg.src, alt: "UGC" },
  { id: 2, src: leadsquaredImg.src, alt: "NSDC" },
  { id: 3, src: logicKnotsImg.src, alt: "NCVET" },
  { id: 4, src: merittoImg.src, alt: "Govt. of Sikkim" },
  { id: 5, src: tribujteImg.src, alt: "Directorate General of Training" },
  { id: 6, src: wheeboxImg.src, alt: "Association of Indian Universities" },
];
export function RecognitionsSection() {
  return (
    <section className="relative py-10 md:py-14 bg-gradient-to-b from-white via-slate-50/60 to-white">
      <div className="relative max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
        {/* Heading */}

        <Title
          title="Technology Partners"
        // description="At Medhavi, learning is not confined to classrooms — it’s lived through work, innovation, and experience. Every program is built with industry, every lesson leads to action."
        />

        <div className="-mt-8 relative rounded-xl border border-slate-100
         bg-white/80 backdrop-blur-sm shadow-[0_18px_45px_rgba(15,23,42,0.08)] 
         px-4 md:px-6 lg:px-8 py-5 md:py-10 lg:py-14">

          <div className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-sky-200/80 to-transparent" />

          <div className="w-full">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={20}
              loop={true}
              autoplay={{ delay: 2500, disableOnInteraction: false, }}
              breakpoints={{
                320: { slidesPerView: 2 },
                640: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                1024: { slidesPerView: 5 },
                1280: { slidesPerView: 6 },
              }}
            >
              {RECOGNITIONS.map((item) => (
                <SwiperSlide key={item.id}>
                  <div className="flex justify-center">
                    <div
                      className="group bg-white
                      border border-black/40
                      px-3 py-4 md:px-5 md:py-4
                      transition-all duration-300
                      hover:shadow-[0_14px_30px_rgba(15,23,42,0.12)]"
                    >
                      <Image
                        src={item.src}
                        alt={item.alt}
                        width={177}
                        height={60}
                        className="transition duration-200 group-hover:scale-105"
                      />
                    </div>

                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>


        </div>
      </div>
    </section>
  );
}
